/* eslint-disable react/prop-types */
import React from 'react';
import { TDR } from 'tdr-common';
import { Policy } from '../checkout/Policy';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useTranslation } from 'react-i18next';
import { resolveLocalizedText } from '@/helpers/resolveLocalizedText';



const PolicySection = React.memo(function PolicySection({ table }: { table: TDR.TableWithPolicies }) {
	const { i18n } = useTranslation();
	return (
		<div className="px-3 py-6 gap-4 flex flex-col">
			{table?.policies?.map((policy) => {
				const display = policy.displays?.[0];
				const title = resolveLocalizedText(display?.title, i18n.language);
				const label = resolveLocalizedText(display?.label, i18n.language);
				const description = resolveLocalizedText(display?.description, i18n.language);
				return <Policy key={policy.id} icon={display?.icon} title={title} label={label}>
					<ReactMarkdown
						remarkPlugins={[remarkGfm]}
						components={{
							// eslint-disable-next-line @typescript-eslint/no-unused-vars
							a({ node, target, children, ...props }) {
								if (props.href?.includes(location.hostname)) {
									return <a {...props} target={target}>{children}</a>;
								}
								else {
									return <a {...props} target='_blank'>{children}</a>;
								}
							}
						}}
					>
						{description || ''}
					</ReactMarkdown>
				</Policy>;
			})}
		</div>
	);
});

export default PolicySection;
